import { _BASIC_CONFIG } from './nfc_libs/basic_config.js';

//import {NFCPortLib, NFCPortError, Configuration, DetectionOption, CommunicationOption, TargetCard} from 'https://cdn.felica-support.sony.biz/webclient/trial/NFCPortLib.js';
//import { NFCPortLib, NFCPortError, Configuration, DetectionOption, CommunicationOption, TargetCard } from './nfc_libs/nfc_port_lib.js';

import { NFCUtils } from './nfc_libs/nfc_utils.js';

import { cjrcLib } from './cjrc_lib.js';

(async () => {

  // justify width
  let loadingControl = function() { }
  loadingControl.prototype = {
    addviewport: async () => {
      return new Promise( (resolve) => {
        const app_fixed_screen_width = 440
        let actual_screen_width = window.outerWidth
        let sig_digit = Math.pow(10, 3)
        let just_scale = Math.ceil(sig_digit * (actual_screen_width / app_fixed_screen_width)) / sig_digit
        let viewport = document.createElement('meta')
        viewport.setAttribute('name', 'viewport')
        viewport.setAttribute('content', `width=device-width, initial-scale=${just_scale}, maximum-scale=${just_scale}`)
        document.getElementsByTagName('head')[0].appendChild(viewport)
        resolve()
      })
    },
    hide: () => {
      let div_loading = document.querySelector('#loading')
      setTimeout( () => {
        div_loading.style.setProperty('opacity', '0')
      }, 500)
      setTimeout( () => {
        document.body.removeChild(div_loading)
      }, 1500)
    }
  }
  // justify width

  let cjrclib = new cjrcLib()

  let header_sticky = document.querySelector("#title-header")
  let header_sticky_offset = header_sticky.offsetTop
  let timerId = {
    error: []
  }

  let pbar = document.querySelector('div#pbar')
  let history_area = document.querySelector('#history_area')
  let show_idm_area = document.querySelector('#show-idm')

  const handle_header_sticky = () => {
    if (window.pageYOffset > header_sticky_offset) {
      header_sticky.classList.add("header-sticky");
    } else {
      header_sticky.classList.remove("header-sticky");
    }
  }
  window.onscroll = () => { handle_header_sticky() }

  const splitStringToByte = (str = null) => {
    return str.match(/.{2}/g).join(' ')
  }

  const enableReadButton = (type = true) => {
    let read_felica = document.querySelector('#read_felica')
    let clear_history = document.querySelector('#clear_history')
    //if(read_felica.disabled) {
    if(type === true) {
      read_felica.removeAttribute('disabled')
      clear_history.removeAttribute('disabled')
    } else {
      read_felica.setAttribute('disabled', 'disabled')
      clear_history.setAttribute('disabled', 'disabled')
    }
  }

  const numberFormatting = (number_to_format = '0', type='yen') => {
    let prefix = ''
    let negative = false
    if(number_to_format < 0) negative = true
    number_to_format = Math.abs(number_to_format)
    switch(type) {
      case 'yen':
        prefix = '&yen;'
        break
    }
    if(negative) { prefix = '&#9650;' + prefix }
    return prefix+''+Number(parseFloat(parseInt(number_to_format, 10)).toFixed(2)).toLocaleString('en', {
      minimumFractionDigits: 0
    });
  }

  const check_webusb_warning = () => {
    if(typeof navigator.usb == 'undefined') {
      document.querySelector('#message_area').innerHTML = ''
      let browser_warning = document.querySelector('#instrunction-01')
      let warning_area = document.querySelector('#browse_warning_area')
      warning_area.innerHTML = ''
      warning_area.appendChild(browser_warning)

      enableReadButton(false)
    }
  }

  // enable debug log to console
  let syslog = NFCUtils.enableDebugLog(_BASIC_CONFIG.debug)

  document.querySelector('#read_felica').addEventListener('click', () => {
    felica_card();
  }, false);

  document.querySelector('#clear_history').addEventListener('click', () => {
    history_area.innerHTML=''
    show_idm_area.innerHTML = ''
    showInstrinction()
  }, false);

  const showInstrinction = () => {
    if(document.querySelector('#history_area').childNodes.length == 0) {
      let show_idm_area = document.querySelector('#show-idm')
      show_idm_area.innerHTML = ''
      document.querySelector('#message_area').innerHTML = ''
      document.querySelector('#message_area').appendChild(
        document.querySelector('#message_area').appendChild(
          (document.querySelector('#instrunction-00').cloneNode(true))
        )
      )
    }
  }

  const showError = (msg = 'Something went wrong.') => {
    let error_msg_template = (document.querySelector('#template-error-design-00')).cloneNode(true)
    while(timerId.error.length > 0) {
      clearTimeout(timerId.error.pop())
    }
    showInstrinction()
    let msg_area = document.querySelector('#message_area')
    error_msg_template.querySelector('#message').innerHTML = msg
    msg_area.innerHTML = ''
    msg_area.appendChild(error_msg_template)
    timerId.error.push(
      setTimeout( () => {
        error_msg_template.style.setProperty('opacity', '0')
      }, 5000)
    )
    timerId.error.push(
      setTimeout( () => {
        msg_area.innerHTML = ''
        showInstrinction()
      }, 5800)
    )
  }

  const handleError = async (msg = 'Something went wrong.', err = {}) => {
    //console.error(msg, err)
    showError(msg)
    await cjrclib.close()
    enableReadButton(true)
    pbar.classList.add('none_hidden')
  }

  // vvvvv App/UI Initialization vvvvv
  let lc = new loadingControl()
  await lc.addviewport()
  lc.hide()
  showInstrinction()
  check_webusb_warning()
  // ^^^^^ App/UI Initialization ^^^^^

  async function felica_card() {
    pbar.classList.remove('none_hidden')
    enableReadButton(false)
    let lib = null;

    show_idm_area.innerHTML = ''
    history_area.innerHTML = ''
    message_area.innerHTML = ''

    await cjrclib.init()
    let device_select = await cjrclib.open()
    if(device_select.success === false) {
      console.error('[ERROR] Card Reader could not properly be selected.')
      await handleError('カードリーダを正常に選択できませんでした。', null)
      return
    }

    try {
      let ret_basic = await cjrclib.detectCard()
      if(ret_basic.success === false) {
        let error_msg = 'カードを検出できませんでした。<br>カードリーダにカードを載せてください。'
        if(ret_basic.data.error_code == 'NOT_CJRC') {
          error_msg = '交通系カードではないようです。<br>交通系カードを載せて再度お試しください。'
        }
        await handleError(error_msg, ret_basic)
        return
      }
      show_idm_area.innerHTML = `[Card ID: ${splitStringToByte(ret_basic.data.idm)}]`
    } catch(err) {
      console.error('[ERROR] during detecting card.', err)
      await handleError('カードを検出中にエラーが発生しました。', ret_basic)
      await cjrclib.close()
      return
    }

    try {
      let ret_history = await cjrclib.getAllCardHistory()
      if(ret_history.success === false) {
        //await handleError('[ERROR] Communication error during getting data.', ret_history.success)
        await handleError('カードのデータ取得中にエラーが発生しました。<br>再度お試しください。', err)
        return
      }

      let template_history_design = document.querySelector('#template-history-design-item-01')
      ret_history.data.decoded.forEach( (record, key) => {
        let record_template = template_history_design.cloneNode(true)
        record_template.querySelector('#history-date').innerHTML = `${record.date}`
        if(record.time != null) record_template.querySelector('#history-date').innerHTML += ` ${record.time}`

        record_template.querySelector('#history-type').innerHTML = `${record.transaction} @${record.console_type}`

        let type_icon = document.createElement('i')
        type_icon.classList.add('material-icons')
        type_icon.innerHTML = 'device_unknown'

        let _inc_dec = '--'
        if(key < ret_history.data.decoded.length - 1) {
          _inc_dec = ret_history.data.decoded[key].balance - ret_history.data.decoded[key + 1].balance
          _inc_dec = numberFormatting(_inc_dec, 'yen')
        }

        record_template.querySelector('#history-inc_dec').innerHTML = `${_inc_dec}`

        if(record.console_is.train) {
          type_icon.innerHTML = 'directions_transit'
          record_template.querySelector('#history-in_station').innerHTML = `${record.in_station.station} (${record.in_station.company})`
          record_template.querySelector('#history-out_station').innerHTML = `${record.out_station.station} (${record.out_station.company})`
        }
        if(record.console_is.bus) {
          type_icon.innerHTML = 'directions_bus'
          // have not suppoted yet
          record_template.querySelector('#history-in_station_all').innerHTML = ''
          record_template.querySelector('#history-out_station_all').innerHTML = ''
        }
        if(record.console_is.product_sale) {
          type_icon.innerHTML = 'local_mall'
          record_template.querySelector('#history-in_station_all').innerHTML = ''
          record_template.querySelector('#history-out_station_all').innerHTML = ''
        }
        if(record.console_is.charge) {
          type_icon.innerHTML = 'local_atm'
          record_template.querySelector('#history-in_station_all').innerHTML =
            `<i class="material-icons">check</i> ${record.in_station.station} (${record.in_station.company})`
          record_template.querySelector('#history-out_station_all').innerHTML = ''
        }

        record_template.querySelector('#history-type-icon').innerHTML=''
        record_template.querySelector('#history-type-icon').appendChild(type_icon)
        record_template.querySelector('#history-balance').innerHTML = `${numberFormatting(record.balance, 'yen')}`

        record_template.querySelector('#history-seq').innerHTML = `(seq:${record.seq_no})`

        history_area.appendChild(record_template)

      })

    } catch(err) {
      //await handleError('[ERROR] Communication error during getting data.', err)
      await handleError('カードと通信中にエラーが発生しました。<br>再度お試しください。', err)
      return
    }

    await cjrclib.close()
    enableReadButton(true)
    pbar.classList.add('none_hidden')
    return
  }

})()
